module.exports = __webpack_public_path__ + "static/media/move.ac353055.wav";